import {useTranslation} from 'react-i18next';
import {Button, List} from '@tickchak/react-share/app';
import {useTheme} from 'styled-components';
import useShow from '../../../../hooks/useShow';
import * as css from './TimetableToolbar.css';
import ChevronFilled from '../../../../assets/icons/ChevronFilled';
import {useTimetableDays} from '../../hooks/useTimetableDays';

function TimetableToolbar() {
    const {t} = useTranslation('timetable');
    const theme = useTheme();
    const dayListShow = useShow();
    const {onPrevDay, onNextDay, onDaySelect, currentDateLabel, conferenceDays, disablePrev, disableNext} = useTimetableDays();

    const prevStyle = {display: 'flex', transform: theme.rtl ? 'rotate(180deg)' : 'rotate(0deg)'};
    const nextStyle = {display: 'flex', transform: theme.rtl ? 'rotate(0deg)' : 'rotate(180deg)'};
    const downStyle = {display: 'flex', transform: 'rotate(-90deg)'};

    const handleDaySelect = ({id}: {id: string | number}) => {
        onDaySelect(Number(id));
        dayListShow.close();
    };

    return (
        <css.rightGroup>
            <Button
                variant="subtle"
                size="chip"
                iconStart={<span style={prevStyle}><ChevronFilled /></span>}
                disabled={disablePrev}
                onClick={onPrevDay}
                ariaLabel={t('prevDay')}
            />
            <css.dateBtnWrap>
                <Button
                    variant="neutral"
                    size="chip"
                    iconEnd={<span style={downStyle}><ChevronFilled /></span>}
                    onClick={dayListShow.isOpen ? dayListShow.close : dayListShow.open}
                    ariaExpanded={dayListShow.isOpen}
                    ariaHaspopup="listbox"
                >
                    {currentDateLabel}
                </Button>
                {dayListShow.isOpen && conferenceDays.length > 0 && (
                    <List
                        show={dayListShow}
                        onItemClick={handleDaySelect}
                        position={{width: '200px', height: 'fit-content'}}
                    >
                        <List.Items>
                            {conferenceDays.map((day, i) => (
                                <List.Item.Item
                                    key={day.key}
                                    id={String(i)}
                                    text={day.label}
                                />
                            ))}
                        </List.Items>
                    </List>
                )}
            </css.dateBtnWrap>
            <Button
                variant="subtle"
                size="chip"
                iconStart={<span style={nextStyle}><ChevronFilled /></span>}
                disabled={disableNext}
                onClick={onNextDay}
                ariaLabel={t('nextDay')}
            />
        </css.rightGroup>
    );
}

export default TimetableToolbar;
